import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {
  MdefRequestPasswordResetFormComponent,
  RequestPasswordResetFormComponent
} from "component-library";
import {AuthenticationService} from "../../config/authentication-service";
import {AuthenticationConfig} from "shared";
import { NotificationService } from "shared";

@Component({
  selector: 'tngh-request-reset-password-page',
  templateUrl: './request-password-reset-page.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RequestPasswordResetFormComponent,
    MdefRequestPasswordResetFormComponent,
  ],
})
export class RequestPasswordResetPageComponent {
  theme: AuthenticationConfig['theme'];

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private notificationService: NotificationService,
    private config: AuthenticationConfig,
  ) {
    this.theme = config.theme ?? 'tngh';
  }

  onSubmit(emailAddress: string) {
    this.authenticationService.resetPasswordRequest(emailAddress).subscribe({
      complete: () => {
        this.notificationService.addSuccessNotification(
          'U heeft wachtwoordherstel aangevraagd',
          'Controleer uw inbox'
        );
      },
      error: () => {
        this.notificationService.addErrorNotification(
          'Wachtwoordherstel mislukt',
          'Probeer het opnieuw of neem contact op met support.'
        );
      }
    });


  }

  onClickBackButton() {
    this.router.navigateByUrl('/');
  }
}
